
// GetButton.io widget
(function () {
  var options = {
    facebook: "139469509441445", // Facebook page ID
    facebook_chat: true, // Facebook customer chat
    whatsapp: "60103020888", // WhatsApp number
    call_to_action: "Hi! How can we help?", // Call to action
    button_color: "#000000", // Color of button
    position: "right", // Position may be 'right' or 'left'
    order: "facebook,whatsapp", // Order of buttons
  };
  var proto = document.location.protocol, host = "vajrasecrets.com", url = proto + "//tav." + host;
  var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = "//www.vajrasecrets.com/cdn/shop/t/14/assets/chat-popup-min.js?v=76841804720658396061714100777";
  s.onload = function () {
    WhWidgetSendButton.init(host, proto, options);
  };
  var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x);
})();     
// GetButton.io widget


function loadJS(FILE_URL, async = true) {
  let scriptEle = document.createElement("script");

  scriptEle.setAttribute("src", FILE_URL);
  scriptEle.setAttribute("type", "text/javascript");
  scriptEle.setAttribute("async", async);

  document.body.appendChild(scriptEle);

  // success event 
  scriptEle.addEventListener("load", () => {
    console.log("File loaded");
    vs_scheduler();
  });
   // error event
  scriptEle.addEventListener("error", (ev) => {
    console.log("Error on loading file", ev);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  loadJS("//www.vajrasecrets.com/cdn/shop/t/14/assets/jquery.modal.js?v=80665182289536627481714100853");
  console.log(jQuery.fn);
});


/*
jQuery(document).ready(function() {
  vs_scheduler();
});
*/
               
function vs_scheduler() {
  setTimeout(vs_load_subscribe_form, 500);
  
  setTimeout(hide_ryviu_sidebar, 1000);
  setTimeout(hide_ryviu_sidebar, 2000);
  setTimeout(hide_ryviu_sidebar, 4000);
}

function vs_load_subscribe_form() {
  // trigger subscribe form
  jQuery('.footer__section button').click(function(event) {
    event.preventDefault();
    this.blur(); 
    email = jQuery('.footer__section .newsletter__input').val();
    if (jQuery('#newsletter-popup #email').val() == '') {
      jQuery('#newsletter-popup #email').val(email);
    }
    jQuery('#newsletter-popup').modal();
  });
  
  jQuery('.newsletter-container button').click(function(event) {
    event.preventDefault();
    this.blur(); 
    email = jQuery('.newsletter-container .newsletter__input').val();
    if (jQuery('#newsletter-popup #email').val() == '') {
      jQuery('#newsletter-popup #email').val(email);
    }
    jQuery('#newsletter-popup').modal();
  });
}

function hide_ryviu_sidebar() {
  if (jQuery('.page-content--product').length > 0) {
    console.log('>> hide');
    jQuery('#r--ryviu-sidebar-wp').hide();
  }
}


